import Section from "../Section";
import BannerSectionStyle2 from "../Section/BannerSection/BannerSectionStyle2";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { IsTokenExpired } from "../../helpers/lib/jwt";
import { editService, getServices } from "../../helpers/lib/axios";
import { useNavigate } from "react-router-dom";
import { PencilIcon } from 'lucide-react';
import { useAppToast } from "../../helpers/lib/useAppToast";

const Services = () => {
    const navigate = useNavigate()
    const toast = useAppToast()
    const [isModalOpen, setIsModalOpen] = useState(false);
    // const [selectedService, setSelectedService] = useState(null);
    const [editForm, setEditForm] = useState({});
    const [services, setServices] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        const token = Cookies.get('noohraToken')
        if (!token) {
            navigate('/signup')
            return;
        }
        if (IsTokenExpired(token)) {
            Cookies.remove("noohraToken");
            navigate('/signup')
            return;
        } else {
            setLoading(true)
            getServices().then(user => {
                setServices(user?.data);
                setLoading(false)
            }).catch(err => console.log(err))
        }
    }, [navigate])

    // Handle edit button click
    const handleEdit = (service) => {
        // setSelectedService(service);
        setEditForm(service);
        setIsModalOpen(true);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setEditForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked :
                type === 'number' ? Number(value) : value
        }));
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        // Add your update logic here
        editService(editForm?._id, editForm).then(data => {
            toast({
                status: 'success',
                description: 'Service updated successfully',
            })
            // Refresh the services list
            getServices().then(user => {
                setServices(user?.data);
                setIsModalOpen(false);
            }).catch(err => {
                toast({
                    status: 'error',
                    description: 'Failed to update service',
                })
                console.log(err)
            })
        })
    };

    // Calculate pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = services.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(services.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (<>
        <BannerSectionStyle2
            bgUrl="/images/about/banner_bg.svg"
            imgUrl="/images/about/banner_img.png"
            title="Services"
            subTitle="Services information"
        />
        <Section
            topMd={170}
            topLg={150}
            topXl={110}
            bottomMd={200}
            bottomLg={150}
            bottomXl={110}
            className='flex justify-center items-center w-full'
        >
            <div className="lg:max-w-[70%] w-full mt-[5%] p-4">
                {/* Table */}
                <div className="w-full overflow-x-auto rounded-lg border border-gray-200">
                    <table className="w-full text-sm text-left">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 font-medium text-gray-500">Name</th>
                                <th className="px-6 py-3 font-medium text-gray-500">Location</th>
                                <th className="px-6 py-3 font-medium text-gray-500">Type</th>
                                <th className="px-6 py-3 font-medium text-gray-500">Price</th>
                                <th className="px-6 py-3 font-medium text-gray-500">Sessions</th>
                                <th className="px-6 py-3 font-medium text-gray-500">Extra</th>
                                <th className="px-6 py-3 font-medium text-gray-500">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {loading ? (
                                // Show a loading indicator or skeleton rows when loading
                                <tr>
                                    <td colSpan={7} className="px-6 py-4 text-center">
                                        <div className="flex justify-center items-center">
                                            <svg
                                                className="animate-spin h-8 w-8 text-gray-500"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <circle
                                                    className="opacity-25"
                                                    cx="12"
                                                    cy="12"
                                                    r="10"
                                                    stroke="currentColor"
                                                    strokeWidth="4"
                                                ></circle>
                                                <path
                                                    className="opacity-75"
                                                    fill="currentColor"
                                                    d="M4 12a8 8 0 018-8v8H4z"
                                                ></path>
                                            </svg>
                                            <span className="ml-4 text-gray-500">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                            ) : currentItems.map((service) => (
                                <tr key={service._id} className="bg-white hover:bg-gray-50">
                                    <td className="px-6 py-4 whitespace-nowrap">{service.name}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{service.location}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{service.type}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">₦{service.price.toLocaleString()}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{service.sessions}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{service.isExtra ? 'Yes' : 'No'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <button
                                            onClick={() => handleEdit(service)}
                                            className="text-[#981D0E] hover:text-[#F5ABAB]"
                                        >
                                            <PencilIcon className="h-5 w-5" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Edit Modal */}
                {isModalOpen && (
                    <div className="fixed z-[100000] inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
                        <div className="bg-white rounded-lg max-w-md w-full p-6">
                            <h2 className="text-xl font-semibold mb-4">Edit Service</h2>
                            <form onSubmit={handleSubmit}>
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={editForm.name}
                                            onChange={handleChange}
                                            className="mt-1 w-full rounded-md border border-gray-300 p-2"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Location</label>
                                        <select
                                            name="location"
                                            value={editForm.location}
                                            onChange={handleChange}
                                            className="mt-1 w-full rounded-md border border-gray-300 p-2"
                                        >
                                            <option value="PHYSICAL">Physical</option>
                                            <option value="VIRTUAL">Virtual</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Type</label>
                                        <select
                                            name="type"
                                            value={editForm.type}
                                            onChange={handleChange}
                                            className="mt-1 w-full rounded-md border border-gray-300 p-2"
                                        >
                                            <option value="INDIVIDUAL">Individual</option>
                                            <option value="GROUP">Group</option>
                                            <option value="ORGANIZATION">Organization</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Price</label>
                                        <input
                                            type="number"
                                            name="price"
                                            value={editForm.price}
                                            onChange={handleChange}
                                            className="mt-1 w-full rounded-md border border-gray-300 p-2"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Sessions</label>
                                        <input
                                            type="number"
                                            name="sessions"
                                            value={editForm.sessions}
                                            onChange={handleChange}
                                            className="mt-1 w-full rounded-md border border-gray-300 p-2"
                                        />
                                    </div>

                                    <div className="flex items-center">
                                        <input
                                            type="checkbox"
                                            name="isExtra"
                                            checked={editForm.isExtra}
                                            onChange={handleChange}
                                            className="h-4 w-4 rounded border-gray-300"
                                        />
                                        <label className="ml-2 text-sm font-medium text-gray-700">Extra Service</label>
                                    </div>
                                </div>

                                <div className="mt-6 flex justify-end space-x-3">
                                    <button
                                        type="button"
                                        onClick={() => setIsModalOpen(false)}
                                        className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="px-4 py-2 bg-[#981D0E] text-white rounded-md text-sm font-medium hover:bg-[#F5ABAB]"
                                    >
                                        Save Changes
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
                <div className="flex items-center justify-between mt-4">
                    <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="px-3 py-1 rounded border border-gray-300 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                    >
                        Previous
                    </button>

                    <div className="flex items-center gap-2">
                        {[...Array(totalPages)].map((_, index) => (
                            <button
                                key={index}
                                onClick={() => handlePageChange(index + 1)}
                                className={`px-3 py-1 rounded text-sm font-medium ${currentPage === index + 1
                                    ? 'bg-[#981D0E] text-white'
                                    : 'border border-gray-300 hover:bg-gray-50'
                                    }`}
                            >
                                {index + 1}
                            </button>
                        ))}
                    </div>

                    <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="px-3 py-1 rounded border border-gray-300 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                    >
                        Next
                    </button>
                </div>
            </div>

        </Section>
    </>);
}

export default Services;